import parseColor from './parseColor';
// This code is copypast from Thunderbolt - https://github.com/wix-private/thunderbolt/blob/1080b5b99467a53af6d63f191e905995abb02eb4/packages/thunderbolt-components/src/components/TPAWidget/tpaStyleUtils.ts#L5
// Since editorSDK get it data from documentService (where there is no reference in color), for backward compatibility we need this logic
var PRIME_COLORS_REFERENCES = [
    'white/black',
    'black/white',
    'primery-1',
    'primery-2',
    'primery-3',
];
var NON_PRIME_COLORS_PREFIX = 'color-';
var getReferenceFromName = function (name) {
    var _a = name.split('_'), colorIndex = _a[1];
    var index = Number(colorIndex);
    return index <= 5
        ? PRIME_COLORS_REFERENCES[index - 1]
        : "".concat(NON_PRIME_COLORS_PREFIX).concat(index - 10);
};
export function getWixColor(_a) {
    var colors = _a.colors, reference = _a.reference, _b = _a.opacity, opacity = _b === void 0 ? 1 : _b;
    var wixColor = colors.find(function (c) { var _a; return ((_a = c.reference) !== null && _a !== void 0 ? _a : getReferenceFromName(c.name)) === reference; }) || null;
    return {
        opacity: opacity,
        value: parseColor(wixColor === null || wixColor === void 0 ? void 0 : wixColor.value, opacity).rgb(),
        name: wixColor === null || wixColor === void 0 ? void 0 : wixColor.name,
    };
}
export var wixColorParam = function (name, opacity) { return function (_a) {
    var colors = _a.colors;
    return getWixColor({ reference: name, opacity: opacity, colors: colors });
}; };
//# sourceMappingURL=getWixColor.js.map